import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { resourceExplorerPayloadDataSelector } from "../../../selectors/current-resource-explorer/resource-explorer-widget/resourceExplorerPayloadDataSelector";
import { resourceExplorerDataGridViewSelector } from "../../../selectors/current-resource-explorer/resourceExplorerDataGridViewSelector";
import { resourceExplorerPathLastItemFilterTreeSelector } from "../../../selectors/current-resource-explorer/path/resourceExplorerPathLastItemFilterTreeSelector";
import { addFilterTreePathToResourceExplorerPayload } from "../../../utils/helpers/path/addFilterTreePathToResourceExplorerPayload";
import { RootState } from "@/store/store";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";

export const resourceExplorerCSVDataFixedCacheKey =
  "postUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsv-fixed-cache-key";

interface ResourceExplorerCSVDataHashGeneratorThunkArgs {
  csvColumns: string[];
  tagKeys: string[];
  dimensions: string[];
}
export const resourceExplorerCSVDataHashGeneratorThunk = createAsyncThunk(
  "resourceExplorer/resourceExplorerCSVDataHashGenerator",
  async (
    {
      csvColumns,
      tagKeys,
      dimensions,
    }: ResourceExplorerCSVDataHashGeneratorThunkArgs,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const payload = resourceExplorerPayloadDataSelector(state);
    const pathLastItemFilterTree =
      resourceExplorerPathLastItemFilterTreeSelector(state);
    const dataGridView = resourceExplorerDataGridViewSelector(state);

    const resourceExplorerFilterSchema = pathLastItemFilterTree
      ? addFilterTreePathToResourceExplorerPayload(
          payload,
          pathLastItemFilterTree,
        )
      : payload;

    const {
      postUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsv,
      postUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsv,
    } = cloudChiprApi.endpoints;

    const endpoint =
      dataGridView === "granular"
        ? postUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsv
        : postUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsv;

    try {
      const response = await dispatch(
        endpoint.initiate(
          {
            resourceExplorerFilterSchema: {
              ...resourceExplorerFilterSchema,
              csv_columns: csvColumns,
              csv_tag_keys: tagKeys,
              csv_dimensions: dimensions,
            },
          },
          { fixedCacheKey: resourceExplorerCSVDataFixedCacheKey },
        ),
      ).unwrap();

      return response.hash;
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
